export default {
  yesNo: [
    {
      label: 'common.yes',
      value: true,
    },
    {
      label: 'common.no',
      value: false,
    },
  ],
  orderStatus: [
    {
      label: 'MATERIAL_ORDER_STATUS.DELIVERY_COMPLETE',
      value: 'DELIVERY_COMPLETE',
    },
    {
      label: 'MATERIAL_ORDER_STATUS.BIDDING',
      value: 'BIDDING',
    },
    {
      label: 'MATERIAL_ORDER_STATUS.PAYMENT_CONFIRMING',
      value: 'PAYMENT_CONFIRMING',
    },
    {
      label: 'MATERIAL_ORDER_STATUS.DELIVERING',
      value: 'DELIVERING',
    },
    {
      label: 'MATERIAL_ORDER_STATUS.CANCEL',
      value: 'CANCEL',
    },
    {
      label: 'MATERIAL_ORDER_STATUS.RETURN',
      value: 'RETURN',
    },
  ],
  fieldInvitationStatus: [
    {
      label: 'common.waiting.accept',
      value: 'INVITED',
    },
    {
      label: 'common.connected',
      value: 'ACCEPTED',
    },
    {
      label: 'common.waiting.accept',
      value: 'DECLINED',
    },
    {
      label: 'common.waiting.accept',
      value: 'CANCELED',
    },
    {
      label: 'common.waiting.accept',
      value: 'RESEND',
    },
  ],
  staffPermission: [
    {
      label: 'setting.staff.permission.active',
      value: true,
    },
    {
      label: 'setting.staff.permission.inactive',
      value: false,
    },
  ],
  constructStatus: [
    {
      label: 'consult.constructStatus.CONSULTING',
      value: 'CONSULTING',
    },
    {
      label: 'consult.constructStatus.WORKING',
      value: 'WORKING',
    },
    {
      label: 'consult.constructStatus.COMPLETE',
      value: 'COMPLETE',
    },
    {
      label: 'consult.constructStatus.DUMMY',
      value: 'DUMMY',
    },
  ],
  spaceType: [
    {
      label: 'field.add.update.spaceType.resident',
      value: 'RESIDENTIAL',
    },
    {
      label: 'field.add.update.spaceType.commercial',
      value: 'COMMERCIAL',
    },
  ],
};
